import CandidateNotes from './CandidateNotes.container';

export default CandidateNotes;
